import { Component } from '@angular/core';

@Component({
    template: '<h2 class="text-center mt-md-5">Page not found</h2>'
})
export class PageNotFoundComponent {

}
